import { createApp } from 'vue'
import App from './App.vue'
import i18n from './i18n'
import router from './router'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

import './assets/main.scss'
import './assets/fonts.scss'

const app = createApp(App)
app.use(router)
app.use(i18n)
app.mount('#app')
